import {
  Alert,
  AlertType,
  schAlertSeverity,
  schAlertStatus,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const AI_ICON_ALERT_TYPES: AlertType[] = [
  schAlertType.enum.inconsistentSubjectQualityRating,
  schAlertType.enum.inconsistentSubjectConditionRating,
];

export const isAiIconAlert = (type: AlertType) => AI_ICON_ALERT_TYPES.includes(type);

export const inconsistentSubjectRating: AlertDefinition = ({ order, propertyDataEntities }) => {
  const improvements = (propertyDataEntities.subject as SubjectPropertyDataState | undefined)
    ?.subjectData.editableData.improvements;
  if (!improvements) return [];

  const alerts: Alert[] = [];
  const triggers = getAlertTriggers({
    fixRoute: schPairedCostRouteItem.enum.features,
    order,
    includeUpdate: true,
  });

  if (
    improvements.uadQuality !== undefined &&
    improvements.aiUadQuality !== undefined &&
    improvements.uadQuality !== improvements.aiUadQuality
  ) {
    alerts.push({
      type: schAlertType.enum.inconsistentSubjectQualityRating,
      status: schAlertStatus.enum.active,
      severity: schAlertSeverity.enum.warning,
      orderType: ['appraisify'],
      message: 'Subject Quality Rating appear inconsistent with the inspection photos.',
      propertyID: 'subject',
      triggers,
      fixingInfo: {
        tips: `Review the following AI findings: ${improvements.aiUadQualityCommentary}`,
        pairedCostRouteItem: schPairedCostRouteItem.enum.features,
        fixingMethod: ['action'],
        commentAlwaysRequired: false,
        targetCellKey: 'subject-editableData.improvements.uadQuality',
        targetCellKeys: ['subject-editableData.improvements.uadQuality'],
      },
    });
  }

  if (
    improvements.uadCondition !== undefined &&
    improvements.aiUadCondition !== undefined &&
    improvements.uadCondition !== improvements.aiUadCondition
  ) {
    alerts.push({
      type: schAlertType.enum.inconsistentSubjectConditionRating,
      status: schAlertStatus.enum.active,
      severity: schAlertSeverity.enum.warning,
      orderType: ['appraisify'],
      message: 'Subject Condition Rating appear inconsistent with the inspection photos.',
      propertyID: 'subject',
      triggers,
      fixingInfo: {
        tips: `Review the following AI findings: ${improvements.aiUadConditionCommentary}`,
        pairedCostRouteItem: schPairedCostRouteItem.enum.features,
        fixingMethod: ['action'],
        commentAlwaysRequired: false,
        targetCellKey: 'subject-editableData.improvements.uadCondition',
        targetCellKeys: ['subject-editableData.improvements.uadCondition'],
      },
    });
  }

  return alerts;
};
